<template>
<div>
    <div v-if="dictob.wait" class="CruisePage__ifloader"><Loader class="CruisePage__loader" /></div>
    <div v-if="!dictob.wait && !dictob.ok" class="search_error">Не удалось получить справочник: {{dictob.reject}}</div>

    <div v-if="dictob.ok"><SFmain
        :properties="dictob.resolve"
        :choosed="newSearch" 
        :last="crsearch_last"
        :ctype="props.ctype"
        @input="SFmainHandle"
        :showFind="!searchObserve"
        class="search__SP__main"
        />
    </div>

    <template v-if="crsearch_last.is && props.pokazat">
        <template v-if="!isFilterStatic">
            <button 
                class="search-filter-btn-mobile"
                @click="doFilterOpen"
                >
                Открыть фильтры
            </button>
            <Modal v-model="isFilterOpen"
                title="Фильтры"
                wrapper-class="animate__animated"
                modal-class="search__SP__popup"
                in-class="animate__fadeInLeft hideScroll"
                out-class="animate__fadeOutLeft hideScroll">
                    <SFaddi
                        :properties="dictob.resolve"
                        :choosed="newSearch" 
                        :last="crsearch_last"
                        :ctype="props.ctype"
                        @input="SFaddiHandle"
                        @reset="SFresetHandle"
                        class="search__SP__filter search-filter"
                    />
            </Modal>
        </template>

        <div class="search__SP search">

            <div class="search__aside">
                <template v-if="dictob.ok && isFilterStatic">
                    <SFaddi
                        :properties="dictob.resolve"
                        :choosed="newSearch" 
                        :last="crsearch_last"
                        :ctype="props.ctype"
                        @input="SFaddiHandle"
                        @reset="SFresetHandle"
                        class="search__SP__filter search-filter"
                    />
                </template>
            </div>

            <div class="search__SP__answer search__content">
                <template v-if="crsearch_last.wait">
                    <Loader class="search__SP__loader" />
                </template>
                <template v-else-if="crsearch_last.isEmpty">
                    <div class="search_answer">
                        <div v-if="crsearch_last.ok" class="search__no-results">
                            <p class="search__title">Круизы по запросу не найдены</p>
                            <p><br><br>Попробуйте упросить запрос</p>
                        </div>
                        <div v-else class="search__error">
                            <p class="search__title">Поиск не удался</p>
                            <p>Мы уже знаем о проблеме. Попробуйте снова через 15 минут. Если вопрос срочный, позвоните нам.</p>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <Naideno :id="crsearch_last.id" :key="crsearch_last.id"></Naideno>    
                </template>
            </div>

        </div>
    </template>

</div>
</template>

<script setup>
const DEBUG_SV = false // включить console.log для отладки url параметров и слежения

import {ref, computed, onMounted, watch, unref, onBeforeUnmount} from 'vue'
import SFmain from '@/comp/SF/SFmain.vue'
import SFaddi from '@/comp/SF/SFaddi.vue'
import Naideno from '@/comp/Naideno/Naideno.vue'
import {properties, nc_eq, cruises_list_par_join} from '@/actions.js'
import { useRouter, useRoute } from 'vue-router/composables'
import useCruiseStore from '@/cstore.js'
import Loader from '@/comp/Loader/Loader.vue'
import {fetch_save} from '@/util.js'
import  Modal  from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'
import 'animate.css'
import {debounceOrIm} from '@/util.js'


const router = useRouter()
const route = useRoute()

const cstore=useCruiseStore()


const props = defineProps({
    ctype: String, 
    pokazat: {
        type: Boolean,
        default: false,
    },
})


const epoch = ref(0)
const dictob = ref(fetch_save({wait: false}))


const isFilterStaticRow=ref(true)

const isFilterStatic = computed({
    get() {
        return isFilterStaticRow.value
    },
    set(val) {
        if (val) {// закрыть фильтр если он показан статически
            isFilterOpen.value = false
        }
        isFilterStaticRow.value = val
    }
})

const isFilterOpen = ref(false)
const mq_filter = window.matchMedia('(max-width: 768px)')
const mq_filter_set = e => {
    isFilterStatic.value = !e.matches
}

onMounted(()=>{
    isFilterStatic.value = !mq_filter.matches
    mq_filter.addListener(mq_filter_set)    
})
onBeforeUnmount(()=>{
    mq_filter.removeListener(mq_filter_set)
})
const doFilterOpen = () => {
    if (!isFilterStatic.value) {// защита, не должно быть такого
        isFilterOpen.value = true
    }
}



const newSearch = ref({
    ship:'', startCity:'', dateStartFrom:'', dateStartTo: '',
    nightsMin: '', nightsMax: '', withPlaces: '', 
    popularRoutes: '', routeCities: '',
    river: '', 
    cruise_id: '', 
    type: '', 
    dps: '', 
    is_klk: '', 
    is_oneway: '',
    minPriceFrom: '', minPriceTo: '',
})
const newSearchEpoch = ref(0) // возраст данных
const newExecEpoch = ref(0)
const searchObserve = ref(false)

const SFresetHandle = () => {
    let vals = {
        ship:'', startCity:'', dateStartFrom:'', dateStartTo: '',
        nightsMin: '', nightsMax: '', 
        withPlaces: '1', 
        popularRoutes: '', routeCities: '',
        river: '', 
        cruise_id: '', 
//        type: props.ctype, 
        dps: '', 
        is_klk: '', 
        is_oneway: '',
        minPriceFrom: '', minPriceTo: '',
    }
    newSearchVector(vals, true)
}


const SFmainHandle = (vals, submit) => {
    if (submit) {
        newSearchVector(null,true)
    } else {
        let isNew = newSearchVector(vals)
        if (isNew && !searchObserve.value) {
            newSearchVector(null,true)
        }
    }
}

const SFaddiHandle = SFmainHandle

let newSearchIfNeeded_debounce = null

const newSearchIfNeeded = () => {
    let { wait } = unref(crsearch_last)
    let observe = unref(searchObserve)

    DEBUG_SV && console.log('newSearchIfNeeded', 
        'wait', wait, 
        'observe', observe, 
        newSearchEpoch.value > newExecEpoch.value ? 'isNew' : 'old'  
    )

    if (observe && !wait && newSearchEpoch.value > newExecEpoch.value) {
        let vals = newSearch.value
        newExecEpoch.value = Date.now()

        cstore.crsearch_start( vals ).then( () => newSearchIfNeeded_debounce()  )

        let query={...vals, ...nc_eq()}
        router.push({name: 'CruiseList', query })    
    }else{
        DEBUG_SV && console.log('newSearchIfNeeded', 'finish OR skip')
    }
}

newSearchIfNeeded_debounce = debounceOrIm( newSearchIfNeeded, 1000 )


const newSearchVector = ( vals, newObserve ) => {
    DEBUG_SV && console.log('newSearchVector', vals, 'newObserve', newObserve)    
    let isNew = false
    if (vals) {
        ["ship", "startCity", "dateStartFrom", "dateStartTo",
         "nightsMin", "nightsMax", "withPlaces", "popularRoutes", 
         "routeCities", "river", "cruise_id", "type", "dps", "is_klk", "is_oneway",
         "minPriceFrom", "minPriceTo",
        ].forEach( ff => {
            if  (ff in vals) {
                let n = vals[ff]
                let old = newSearch.value[ff]
                if (n!==old) {
                    newSearch.value[ff] = n
                    isNew = true
                    DEBUG_SV && console.log('newSearchVector', ff, n , 'old=', old)
                }
            }
        } )
    }

    if (isNew) {// игнорим пустую хрень
        newSearchEpoch.value = Date.now()
    }

    let tryNow = false
    if (true === newObserve) {
        if (newObserve !== searchObserve.value) {// нажали на кнопку поиска
            newSearchEpoch.value = Date.now()
        }
        searchObserve.value = newObserve
        tryNow = true // reset - мгновенный
    } else if (false === newObserve) {
        searchObserve.value = newObserve // больше ничего не надо
    }
    newSearchIfNeeded_debounce( tryNow )
//    newSearchIfNeeded()

    return isNew

}


/***********************************************
 *  достаем параметры из query и передаем внутрь
 */

const list_par_from_route = () => {
    let {type} = router.currentRoute.query
    let initQuery = {}
    if (props.ctype === type) {
        initQuery = router.currentRoute.query
    }

    let {ship, startCity, dateStartFrom, dateStartTo, nightsMin, nightsMax, withPlaces, popularRoutes, routeCities, river, cruise_id, dps, is_klk, is_oneway, minPriceFrom, minPriceTo,} = initQuery

    ship = ship || ''
    startCity = startCity || ''
    dateStartFrom = dateStartFrom || ''
    dateStartTo = dateStartTo || ''
    nightsMin = nightsMin || ''
    nightsMax = nightsMax || ''
    withPlaces = ['','1'].includes(withPlaces) ? withPlaces : '1' // то же в cruises_list_par
    routeCities = routeCities || ''
    river = river || ''
    popularRoutes = popularRoutes || ''
    cruise_id = cruise_id || ''
    is_klk = ['','1'].includes(is_klk) ? is_klk : '' // приводим к норме
    is_oneway = ['','1'].includes(is_oneway) ? is_oneway : '' // приводим к норме
    dps = dps || ''
    let ret = {ship, startCity, dateStartFrom, dateStartTo, nightsMin, nightsMax, withPlaces, popularRoutes, routeCities, river, cruise_id, type: props.ctype, dps, is_klk, is_oneway, minPriceFrom, minPriceTo}
    return ret
}

const crsearch_last = computed( () => {
    let ctype = props.ctype
    let last = cstore.crsearch.at(-1)
    let ret
    if (last && ctype === last.params.type) {
        ret = {...last, is: true }
    } else {
        ret = {id: '', is: false, wait: false, params: {}}
    }
    return ret
} )


/***********************************************
 *   начальный словарик и поиск при первчиноый загрузке
 */

const change_dict = () => {
    epoch.value = epoch.value + 1
    const epoch_on = unref(epoch)
    dictob.value  = fetch_save({wait: true})
    properties({type: props.ctype}).then( resolve => {
        if (epoch.value === epoch_on) {// запрос ушедший в таймаут не перебьет последний
            dictob.value = fetch_save({resolve})
        }
    }, reject => {
        if (epoch.value === epoch_on) {
            dictob.value = fetch_save({reject})
        }
    } )
}



const process_in = ( [ctype, join, pokazat], [old_ctype, old_join, old_pokazat] ) => {
    DEBUG_SV && console.log("process_in", Date.now() - newExecEpoch.value , [ctype, join, pokazat], [old_ctype, old_join, old_pokazat] )

    if (ctype !== old_ctype) {
        DEBUG_SV && console.log("process_in", 'change_dict')
        change_dict()
    }

    if (!old_ctype) {// первичная загрузка, старого еще нету
        DEBUG_SV && console.log("process_in", 'первичная загрузка')
        newSearchVector( list_par_from_route(), pokazat ) // регистрируем новый вектор поиска
    } else if (Date.now() - newExecEpoch.value > 5) {// запрос на поиск меняет url. Мы игнорируем собственные изменения url
        // мы пришли сюда по ссылке, либо кто-то вставил скопированную ссылку
        DEBUG_SV && console.log("process_in", 'по ссылке', pokazat ? 'pokazat' : '')
        newSearchVector( list_par_from_route(), pokazat )
    }
}

watch( 
    [ 
        () => props.ctype,
        () => cruises_list_par_join( route.query ),
        () => props.pokazat,
    ],

    process_in,

    { immediate: true }
)


</script>
